export function loadEnv(): Record<string, string | undefined> {
  if (typeof process === 'undefined' || typeof process.env === 'undefined') {
    // In CommonJS builds, import.meta is not available, so we return empty object
    try {
      // Use eval to avoid TypeScript compilation errors in CommonJS builds
      // biome-ignore lint/security/noGlobalEval: this shim intentionally probes import.meta in non-ESM output.
      const importMeta = (0, eval)('import.meta');
      if (
        typeof importMeta === 'object' &&
        typeof importMeta.env === 'object'
      ) {
        return importMeta.env as unknown as Record<string, string | undefined>;
      }
    } catch {
      // import.meta not available (CommonJS build)
    }
    return {};
  }
  return process.env;
}
